import Select from "./FormGroup/Select";
import Info from "./FormGroup/Info";
import Input from "./FormGroup/Input";
import DateTime from "./FormGroup/DateTime";
import Checkbox from "./FormGroup/Checkbox";

export const FormGroup = {
    Select,
    Input,
    DateTime,
    Info,
    Checkbox
}
